import { Priority } from "../enums";
import { AddTicketCommentInput } from "../ticket-comment/add-ticket-comment-input";

export class TicketInput {
    public customerProjectId?: number | null;
    public priority: Priority | null;
    public ticketTypeId?: number | null;
    public title: string;
    public addTicketCommentInput: AddTicketCommentInput;
    public headerId: number | null;
    constructor() {
        this.customerProjectId = null;
        this.priority = null;
        this.ticketTypeId = null;
        this.title = '';
        this.addTicketCommentInput = new AddTicketCommentInput();
        this.headerId = null;
    }
}
